import { StockJwtAxios } from '@/packaging';
import { JwtAxios } from '@/packaging';

export const stockLinkAPI = {

  GetStockLinkSiteList: async type => {
    const axios = getAxiosByHost();
    const res = axios.get(`/StockLink/GetStockLinkSiteList?type=${type}`);
    return res;
  },
  SearchStockLinkProduct: async (connectionId, body) => {
    const axios = getAxiosByHost();
    const res = axios.post(`/StockLink/SearchStockLinkProduct?connectionId=${connectionId}`, body);
    return res;
  },
  DoStockLink: async (id, body) => {
    const axios = getAxiosByHost();
    const res = axios.post(`/StockLink/DoStockLink?id=${id}`, body);
    return res;
  },
  SearchStockLinkFailLog: async body => {
    const axios = getAxiosByHost();
    const res = axios.post(`/StockLink/SearchStockLinkFailLog`, body);
    return res;
  },
  GetStockLinkSiteListInUse: async type => {
    const axios = getAxiosByHost();
    const res = axios.get(`/StockLink/GetStockLinkSiteListInUse?type=${type}`);
    return res;
  },

  GetSourchedListInUse: async type => {
    const res = JwtAxios.get(`/StockLink/GetSourchedListInUse?type=${type}`);
    return res;
  },

  TestServerNoLog: async (id,serverNo) => {
    const axios = getAxiosByHost();
    const res = axios.post(`/StockLink/TestServerNoLog?id=${id}&serverNo=${serverNo}`);
    return res;
  },

  // 필터 설정 관련 API
  GetFilterSettings: async userid => {
    const axios = getAxiosByHost();
    const res = await axios.get(`/StockLink/GetFilterSettings?userid=${encodeURIComponent(userid)}`);
    return res;
  },
  SaveFilterSetting: async body => {
    const axios = getAxiosByHost();
    const res = await axios.post(`/StockLink/SaveFilterSetting`, body);
    return res;
  },
  DeleteFilterSetting: async (filterIdx, userid) => {
    const axios = getAxiosByHost();
    const res = await axios.delete(`/StockLink/DeleteFilterSetting?filterIdx=${filterIdx}&userid=${encodeURIComponent(userid)}`);
    return res;
  },
  DeleteFailedStockLinkProducts: async (connectionId, body) => {
    const axios = getAxiosByHost();
    const res = await axios.post(`/StockLink/DeleteFailedStockLinkProducts=?connectionId=${connectionId}`, body);
    return res;
  },
  // 실패한 마켓 목록 가져오기
  GetFailedMarketList: async (connectionId, body) => {
    const axios = getAxiosByHost();
    const res = await axios.post(`/StockLink/GetFailedMarketList?connectionId=${connectionId}`, body);
    return res;
  },
  // 실패한 마켓만 삭제 처리
  InventoryFailItemSetStatusChange: async (connectionId, body) => {
    const axios = getAxiosByHost();
    const res = await axios.put(`/StockLink/InventoryFailItemSetStatusChange?connectionId=${connectionId}`, body);
    return res;
  },
  DoStockLinkDirect: async (connectionId, body) => {
    const axios = getAxiosByHost();
    const res = await axios.post(`/StockLink/DoStockLinkDirect?id=${connectionId}`, body);
    return res;
  },
};

const getAxiosByHost = () => {
  if (typeof window === 'undefined') return JwtAxios; // SSR 대응

  const hostname = window.location.hostname;

  const useStockAxiosHosts = ['crosssell.co.kr', 'localhost:8080', 'stock.overlink.kr'];

  if (useStockAxiosHosts.includes(hostname)) {
    return StockJwtAxios;
  }
  return JwtAxios;
};
